import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { estAutorizacionDirecta } from "../../Categorias y Estados/estAutorizacionDirecta";
import { Clientes } from "../../Clientes/Clientes";
import { Personal } from "../../Personal/Personal";
import { Productos } from "../../Productos/Productos";
import { Servicios } from "../../Servicios/Servicios";
import { Tiendas } from "../../Tiendas/Tiendas";

const currentDate = new Date();

const columns = () =>
(
    {
        vc_clientes: new EntityColumn<string[]>({ name: 'vc_clientes', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Clientes', isArray: true }),
        vc_productos: new EntityColumn<string[]>({ name: 'vc_productos', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Productos', isArray: true }),
        vc_personales: new EntityColumn<string[]>({ name: 'vc_personales', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Personal', isArray: true }),
        vc_tiendas: new EntityColumn<string[]>({ name: 'vc_tiendas', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Tiendas', isArray: true }),
        vc_servicios: new EntityColumn<string[]>({ name: 'vc_servicios', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Servicios', isArray: true }),
        d_fecha_visita_desde: new EntityColumn<Date>({ name: 'd_fecha_visita_desde', type: 'date', flags: c.Edit, prompt: 'Fecha Visita Desde', defaultValue: currentDate }),
        d_fecha_visita_hasta: new EntityColumn<Date>({ name: 'd_fecha_visita_hasta', type: 'date', flags: c.Edit, prompt: 'Fecha Visita Hasta', defaultValue: currentDate }),
        d_fecha_realizado_desde: new EntityColumn<Date>({ name: 'd_fecha_realizado_desde', type: 'date', flags: c.Edit, prompt: 'Fecha Hora Realizado Desde', defaultValue: currentDate }),
        d_fecha_realizado_hasta: new EntityColumn<Date>({ name: 'd_fecha_realizado_hasta', type: 'date', flags: c.Edit, prompt: 'Fecha Hora Realizado Hasta', defaultValue: currentDate }),
        c_autorizacion_directa_status_id: new EntityColumn<string>({ name: 'c_autorizacion_directa_status_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Autorización', defaultValue: 'PENDIENTE' }),
        ...DefaultColumns()
    }
)

const lookups = () =>
(
    {
        'Clientes': {
            name: 'Clientes',
            viewMapping: { keyIndex: 0, descriptionIndex: 2 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Clientes(client, parentKeys)
        },
        'Productos': {
            name: 'Productos',
            viewMapping: { keyIndex: 0, descriptionIndex: 4 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Productos(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Personal(client, parentKeys)
        },
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: { keyIndex: 0, descriptionIndex: 4 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Tiendas(client, parentKeys)
        },
        'Servicios': {
            name: 'Servicios',
            viewMapping: { keyIndex: 0, descriptionIndex: 2 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Servicios(client, parentKeys)
        },
        'AutorizacionDirecta': {
            name: 'AutorizacionDirecta',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new estAutorizacionDirecta(client, parentKeys)
        },
    }
)

export class DatosServiciosAutorizacionProductosAppSupervisorFiltersDef extends EntityDefinition {

    columns = columns();
    views = {};
    lookups = lookups();

    constructor() {
        super('DatosServiciosAutorizacionProductosAppSupervisorFilters');
    }
}